<template>
  <div>
    <div class="mb-4 flex flex-wrap items-center justify-between gap-4">
      <label class="input input-bordered w-full max-w-xs">
        <i class="fa-solid fa-magnifying-glass text-base-content/80"></i>
        <input
          type="text"
          placeholder="Tìm kiếm theo tên..."
          :value="keyword"
          @input="handleSearch"
        />
      </label>
      <CampaignCreateModal />
    </div>
    <div class="overflow-x-auto">
      <template v-if="!isLoading">
        <CampaignCard
          v-for="c in campaigns"
          :key="c.id"
          :campaign="{ ...c, agentCount: getStatForCampaign(c.id) }"
        />
      </template>
      <div v-if="isLoading" class="text-center">Đang tải dữ liệu...</div>
      <div v-else-if="isError" class="text-error text-center">
        Lỗi khi tải dữ liệu: {{ error?.message }}
      </div>
      <div v-else-if="!campaigns || campaigns.length === 0" class="text-center">
        Không có chiến dịch nào.
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { number_from_query, str_from_query } from "@/api";
import CampaignCard from "@/components/Campaign/CampaignCard.vue";
import CampaignCreateModal from "@/components/Campaign/CampaignCreateModal.vue";
import { useCampaigns } from "@/composables/useCampaigns";
import { router } from "@/router/router";
import { computed, ref } from "vue";

export interface Campaign {
  id: string;
  name: string;
  description: string;
  createdAt: string;
}

const keyword = computed(() => str_from_query("keyword") || "");
const debounceTimer = ref<ReturnType<typeof setTimeout> | null>(null);

const handleSearch = (event: Event) => {
  const target = event.target as HTMLInputElement;
  const newKeyword = target.value;

  if (debounceTimer.value) {
    clearTimeout(debounceTimer.value);
  }

  debounceTimer.value = setTimeout(() => {
    router.push({
      query: {
        ...router.currentRoute.value.query,
        keyword: newKeyword || undefined,
        page: undefined,
      },
    });
  }, 500);
};

const {
  campaigns,
  isLoadingCampaigns,
  isLoadingStats,
  isError,
  error,
  getStatForCampaign,
} = useCampaigns({
  keyword,
  time_from: computed(() => number_from_query("time_from", 0)),
  time_to: computed(() => number_from_query("time_to", 0)),
  page: computed(() => number_from_query("page", 1)),
  size: computed(() => number_from_query("size", 10)),
  refetchInterval: 5 * 60 * 1000,
  refetchIntervalInBackground: true,
});

const isLoading = computed(
  () => isLoadingCampaigns.value || isLoadingStats.value,
);
</script>
